<template>
  <div
    class="cards flex al-center"
    :class="{ 'about-card': $route.params.path1 == 'about-us' }"
  >
    <div
      class="flex al-center pointer"
      @click="card_link_dropdown = !card_link_dropdown"
      v-click-outside="hide"
    >
      <svg-components name="card" />
      <div class="label bold uppercase">{{ $fn.tr("ბარათები") }}</div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="7.857"
        viewBox="0 0 10 7.857"
      >
        <path
          id="Icon_material-play-arrow"
          data-name="Icon material-play-arrow"
          d="M12,7.5v10l7.857-5Z"
          transform="translate(17.5 -12) rotate(90)"
          fill="#4d4d4f"
        />
      </svg>
    </div>

    <transition name="cards-links-dropdown">
      <div
        @mousemove="cursorChange(true)"
        @mouseleave="cursorChange(false)"
        class="cards__card-links flex column"
        v-if="card_link_dropdown"
      >
        <div class="flex column pb-21 cards__card-link">
          <router-link
            :to="_.get(loyal_card_link, 'full_url')"
            class="flex al-center pointer"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="26.098"
              height="18"
              viewBox="0 0 26.098 18"
              class="mr-10 pointer"
            >
              <g
                id="Group_8840"
                data-name="Group 8840"
                transform="translate(-1312.059 -147.646)"
              >
                <path
                  id="download"
                  d="M263.387,235.14c-8.37,0-18.513,0-22.5,0a1.713,1.713,0,0,0-1.755,1.8v14.4a1.8,1.8,0,0,0,1.8,1.8h22.5a1.8,1.8,0,0,0,1.8-1.8v-14.4a1.874,1.874,0,0,0-1.845-1.8Zm0,5.85h-22.5v-4.05h22.5Zm-22.5,10.349v-8.549h22.5v8.549Zm15.3-3.6h5.4v.9h-5.4Z"
                  transform="translate(1072.925 -87.493)"
                  fill="#1a1a1a"
                />
                <path
                  id="Path_10206"
                  data-name="Path 10206"
                  d="M3.888,6.159a.44.44,0,0,0-.41,0L1.885,7a.44.44,0,0,1-.639-.464l.3-1.775a.441.441,0,0,0-.127-.39L.133,3.112A.44.44,0,0,1,.378,2.36L2.16,2.1a.441.441,0,0,0,.332-.241l.8-1.615a.441.441,0,0,1,.79,0l.8,1.615a.44.44,0,0,0,.332.241l1.782.259a.44.44,0,0,1,.244.751L5.944,4.368a.441.441,0,0,0-.127.39l.3,1.775A.44.44,0,0,1,5.482,7Z"
                  transform="translate(1316.026 156.129)"
                  fill="#1a1a1a"
                  fill-rule="evenodd"
                />
              </g>
            </svg>

            <span class="uppercase pangram-extrabold mr-10 pointer">
              {{ $fn.tr("ლოიალობის ბარათი") }}
            </span>
            <svg
              class="pointer"
              xmlns="http://www.w3.org/2000/svg"
              width="6.286"
              height="8"
              viewBox="0 0 6.286 8"
            >
              <path
                id="Icon_material-play-arrow"
                data-name="Icon material-play-arrow"
                d="M0,8V0L6.286,4Z"
                fill="#1a1a1a"
              />
            </svg>
          </router-link>

          <router-link
            :to="_.get(cabinet_link, 'full_url')"
            class="flex al-center pl-36 mt-14 pointer"
            v-if="$cookies.get('_uctoken') !== null"
          >
            <svg
              class="pointer"
              xmlns="http://www.w3.org/2000/svg"
              width="6.286"
              height="8"
              viewBox="0 0 6.286 8"
            >
              <path
                id="Icon_material-play-arrow"
                data-name="Icon material-play-arrow"
                d="M12,7.5v8l6.286-4Z"
                transform="translate(-12 -7.5)"
                fill="#4d4d4f"
              />
            </svg>
            <span class="f-13 bold ml-10 pointer">{{
              $fn.tr("პირადი კაბინეტი")
            }}</span>
          </router-link>
          <a
            :href="_.get($store.state.main.indx, 'unicardAuthUrl')"
            class="flex al-center pl-36 mt-14 pointer"
            v-else
            target="_blank"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="6.286"
              height="8"
              viewBox="0 0 6.286 8"
              class="pointer"
            >
              <path
                id="Icon_material-play-arrow"
                data-name="Icon material-play-arrow"
                d="M12,7.5v8l6.286-4Z"
                transform="translate(-12 -7.5)"
                fill="#4d4d4f"
              />
            </svg>
            <span class="f-13 bold ml-10 pointer">{{
              $fn.tr("პირადი კაბინეტი")
            }}</span>
          </a>
        </div>

        <router-link
          :to="_.get(gift_card_link, 'full_url')"
          class="flex al-center pt-21 cards__card-link pointer"
        >
          <svg
            class="pointer"
            xmlns="http://www.w3.org/2000/svg"
            width="26.375"
            height="23"
            viewBox="0 0 26.375 23"
          >
            <path
              id="download"
              d="M263.645,236H255.55a3.294,3.294,0,0,0-5.275-3.82l-3.82,3.82h-.137l-2.683-2.683a2.6,2.6,0,0,0-2.865-.591,2.627,2.627,0,0,0-1.183,3.911,1.819,1.819,0,0,0-.455,1.182v14.552a1.824,1.824,0,0,0,1.819,1.819H263.69a1.824,1.824,0,0,0,1.819-1.819V237.822A1.894,1.894,0,0,0,263.645,236Zm0,5.912H240.908v-4.093h22.737Zm-12.1-8.458A1.491,1.491,0,0,1,254.1,234.5a1.514,1.514,0,0,1-1.5,1.5H249Zm-10.141.955a.836.836,0,0,1,.864.182l1.41,1.41h-2a.82.82,0,0,1-.273-1.591Zm-.5,17.962v-8.64h22.737v8.64Zm15.461-3.638h5.457v.91h-5.457Z"
              transform="translate(-239.134 -231.193)"
              fill="#1a1a1a"
            />
          </svg>

          <span class="uppercase pangram-extrabold ml-10 mr-10 pointer">
            {{ $fn.tr("სასაჩუქრე ბარათი") }}
          </span>

          <svg
            class="pointer"
            xmlns="http://www.w3.org/2000/svg"
            width="6.286"
            height="8"
            viewBox="0 0 6.286 8"
          >
            <path
              id="Icon_material-play-arrow"
              data-name="Icon material-play-arrow"
              d="M0,8V0L6.286,4Z"
              fill="#1a1a1a"
            />
          </svg>
        </router-link>
      </div>
    </transition>
  </div>
</template>
<script>
import SvgComponents from "./SvgComponents.vue";

export default {
  components: {
    SvgComponents
  },
  data() {
    return {
      card_link_dropdown: false
    };
  },
  computed: {
    loyal_card_link() {
      return this.$store.state.main.indx.menus.filter(menu =>
        menu.configs.includes("loyal-card")
      )[0];
    },
    gift_card_link() {
      return this.$store.state.main.indx.menus.filter(menu =>
        menu.configs.includes("gift-card")
      )[0];
    },
    cabinet_link() {
      return this.$store.state.main.indx.menus.filter(menu =>
        menu.configs.includes("cabinet-page")
      )[0];
    }
  },
  methods: {
    hide() {
      this.card_link_dropdown = false;
    },
    cursorChange(val) {
      this.$store.commit("main/setState", { key: "blackCursor", val: val });
    }
  }
};
</script>

<style lang="scss">
// .cards__card-links{
//   .pointer{
//     cursor: pointer !important;
//   }
// }
</style>
